import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiDelete, apiGet, apiPost, apiPut } from '../lib/http.js';

const LIST_KEY = ['invitados'];
const STATS_KEY = ['stats'];

async function fetchInvitados() {
  return apiGet('/api/invitados');
}

async function createInvitado(payload) {
  return apiPost('/api/invitados', payload);
}

async function updateInvitado({ id, ...payload }) {
  return apiPut(`/api/invitados/${id}`, payload);
}

async function removeInvitado(id) {
  return apiDelete(`/api/invitados/${id}`);
}

// Hooks backing the AdminInvitados page (FR-5, FR-6, FR-7).
// All mutations invalidate both the invitados list AND the stats cards
// so the admin sees live counts without manual refresh.
export function useInvitados() {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: LIST_KEY,
    queryFn: fetchInvitados,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: LIST_KEY });
    queryClient.invalidateQueries({ queryKey: STATS_KEY });
  };

  const createMutation = useMutation({
    mutationFn: createInvitado,
    onSuccess: invalidate,
  });

  const updateMutation = useMutation({
    mutationFn: updateInvitado,
    onSuccess: invalidate,
  });

  const removeMutation = useMutation({
    mutationFn: removeInvitado,
    onSuccess: invalidate,
  });

  return {
    query,
    createMutation,
    updateMutation,
    removeMutation,
  };
}

export { LIST_KEY as INVITADOS_LIST_KEY, STATS_KEY as INVITADOS_STATS_KEY };